export const scrollTo = (selector: string, options?: ScrollIntoViewOptions) => {
  document.querySelector(selector)?.scrollIntoView({
    behavior: 'smooth',
    ...options,
  });
};
